import React, {FC} from "react";
import FilterForm from "components/FilterForm/(flight-search-form)/FilterForm";
import {EventType} from "data/types";

export interface SectionFilterProps {
  className?: string;
  fetchEvents: (params?: Record<string, any>) => void;
  onFilter: (events: EventType[]) => void;
}

const SectionFilter: FC<SectionFilterProps> = ({
  className = "",
  fetchEvents,
  onFilter,
}) => {
  return (
    <div
      className={`nc-SectionHero flex flex-col-reverse lg:flex-col relative ${className}`}
      data-nc-id="SectionHero"
    >
      {/* <div className="hidden lg:block z-10 mb-12 lg:mb-0 lg:-mt-40 w-full"> */}
      <div className="z-10 mb-12 lg:mb-0 lg:-mt-40 w-full">
        <FilterForm fetchEvents={fetchEvents} onFilter={onFilter} />
      </div>
    </div>
  );
};

export default SectionFilter;
